// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37PW1","toggleWrap":"styles_toggleWrap__2vB_S","content":"styles_content__3Z5e8","selectAreaCode":"styles_selectAreaCode__UuyWe"};